import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Docs from './pages/Docs';
import Premium from './pages/Premium';
import PaymentSuccess from './pages/PaymentSuccess';
import Beta from './pages/Beta';
import Legal from './pages/Legal';

function App() {
  return (
    <div className="min-h-screen bg-gray-custom-950 text-white">
      <Navbar />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/docs/*" element={<Docs />} />
          <Route path="/premium" element={<Premium />} />
          <Route path="/payment-success" element={<PaymentSuccess />} />
          <Route path="/beta" element={<Beta />} />
          <Route path="/legal/*" element={<Legal />} />
        </Routes>
      </main>
    </div>
  );
}

export default App;